import styled from "styled-components"

/**
 * Columns come from the card's minimum width rather than hardcoded per-breakpoint
 * counts, so the grid reflows continuously. Lands near mobile's 2/3/4 columns.
 */
export const CardGrid = styled.ul.attrs({ role: "list" })`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${({ theme }) => theme.cardMinWidth}, 1fr));
  gap: ${({ theme }) => theme.spacing.lg};
  margin: 0;
  padding: 0;
  list-style: none;
`
